import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';

const MonthlyHeader = () => {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-gray-200 pb-4 gap-4">
      <div>
        {/* Breadcrumb Navigation */}
        <div className="flex items-center gap-1.5 text-xs text-gray-400 font-semibold mb-1">
          <span className="cursor-pointer hover:text-gray-600 transition">Rota</span>
          <span>&gt;</span>
          <span className="text-gray-800">Add New Monthly Rota</span>
        </div>
        
        {/* Main Title Headers */}
        <h1 className="text-xl font-black text-gray-900 tracking-tight">Add New Monthly Rota</h1>
        <p className="text-xs text-gray-400 font-medium mt-0.5">
          Schedule staff operational calendars, map compliance checklists, and coordinate shifts across a 31-day cycle timeline.
        </p>
      </div>

      {/* Action Navigation Button */}
      <button 
        type="button"
        className="flex items-center gap-2 px-3 py-1.5 border border-gray-300 rounded-md text-xs font-bold text-gray-600 bg-white hover:bg-gray-50 transition shadow-sm shrink-0"
      >
        <FaArrowLeft size={10} className="text-gray-400" /> Back to Rota
      </button>
    </div>
  );
};

export default MonthlyHeader;
